import { Navigate, useParams } from "react-router-dom";
import SaveBras from "../../shared/component/save_bras/SaveBras";
import { useFetchGetBrasById } from "@/shared/actions/erp/configuracion-red/bras.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";

export default function UpdateBrasPage() {

  const { id } = useParams();

  const { data, isLoading } = useFetchGetBrasById(id!)

  if (isLoading) return <LoaderComponent />

  if (!data) return <Navigate to={`${ROUTER_PATHS.configuracionRED.brasNav}`} />

  return <SaveBras
    title="Editar Bras"
    dataBras={data?.data}
  />

}